import { Input, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';
import { Component } from '@angular/core';
import { GeneralService } from 'src/app/service/general-service';

@Component({
  selector: 'app-order-type-log',
  templateUrl: './order-type-log.component.html',
  styleUrls: ['./order-type-log.component.scss']
})
export class OrderTypeLogComponent implements OnChanges {
  @Input() visibleOrderTypeLog: boolean;
  @Input() orderTypeId: any;
  @Input() orderTypeName: any;
  @Output() visibleOrderTypeLogChange = new EventEmitter<boolean>();
  @Output() closeModal = new EventEmitter();

  datas: any[] = [];
  loading = false;

  // dòng log đang xem chi tiết (popup detail cho nội dung thay đổi dài)
  selectedLog: any = null;
  isVisibleDetail = false;

  constructor(
    private generalService: GeneralService
  ) { }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.visibleOrderTypeLog && this.orderTypeId) {
      this.getListData();
    }
  }

  getListData() {
    this.loading = true;
    this.generalService.getOrderTypeLogs(this.orderTypeId).subscribe(res => {
      this.datas = res || [];
      this.loading = false;
    }, error => {
      this.loading = false;
    });
  }

  showDetail(item: any) {
    this.selectedLog = item;
    this.isVisibleDetail = true;
  }

  closeDetail() {
    this.isVisibleDetail = false;
    this.selectedLog = null;
  }

  closeModalLog() {
    this.visibleOrderTypeLog = false;
    this.visibleOrderTypeLogChange.emit(false);
    this.closeModal.emit(false);
  }
}
